import { css } from "@emotion/css";
import { TextField, Button } from "@mui/material";

import { BlockListRender, dmeConfig, generalSettings } from "dmeditor";
import type { DME, DMEData } from "dmeditor";
import { FC, useEffect, useState } from "react";
import { fetchImages } from "../components/fetchImage";

export interface SearchEntity {
  schoolImages?: string;
  imageList: string[];
}

type QuizType = React.FunctionComponent<{ open: boolean; onClose: () => void }>;
let Quiz: QuizType;
export const setQuiz = (q: QuizType) => {
  Quiz = q;
};

export const SearchDefinition: DME.Widget = {
  type: "search",
  icon: "matchfit",
  name: "Search",
  category: "basic",
  settings: [
    {
      name: "Background images",
      settingComponent: "input",
      property: ".schoolImages",
      parameters: {
        updateOnUnfocus: true,
      },
      description: "ID, separated by ,",
    },
    ...generalSettings,
  ],
  events: {
    updateData: () => {},
    createBlock: (): DMEData.CreatedBlock<SearchEntity> => {
      return {
        type: "search",
        data: {
          schoolImages: "",
          imageList: [],
        },
        children: [
          {
            id: "search-heading-1",
            type: "heading",
            style: { _: "searchbox-heading" },
            data: {
              level: 1,
              value: "Be Bold. Be Cool. Be Recruited.",
            },
          },
          {
            id: "search-text-1",
            type: "heading",
            style: { _: "searchbox-heading" },
            data: {
              level: 3,
              value: "Search. Find. Explore. Where do you want to go?",
            },
          },
        ],
      };
    },
  },
};

export const Search = (props: DME.WidgetRenderProps<SearchEntity>) => {
  const {
    blockNode: { data },
  } = props;
  const { schoolImages = "" } = data;
  const [openQuiz, setOpenQuiz] = useState(false);
  const [imageList, setImageList] = useState(data.imageList || []);

  useEffect(() => {
    if (!props.blockNode.serverData) {
      fetchImages(schoolImages).then((list) => setImageList(list));
    }
  }, [schoolImages]);

  console.log(imageList);
  return (
    <div>
      <section className="bg-black h-[688px] relative overflow-hidden p-0">
        <div className="absolute grid grid-rows-6 -top-20 -left-20 grid-cols-10 gap-8 w-max kenburns-top">
          {imageList.map((imgItem, index) => (
            <div
              key={imgItem}
              className="h-60 w-48 rounded-lg bg-cover"
              style={{
                backgroundImage: `url(${dmeConfig.general.imagePath(
                  imgItem,
                  "thumbnail"
                )})`,
              }}
            />
          ))}
        </div>
        <div
          className="h-full w-full flex flex-col text-white items-center justify-center gap-y-4 relative z-10 p-4 md:p-0"
          style={{ background: "radial-gradient(black, transparent)" }}
        >
          <BlockListRender
            blockData={(props.blockNode.children || []) as DMEData.BlockList}
            path={props.path}
            mode={props.mode}
          />
          <form action="/app/search" method="get">
            <div className=" w-11/12 flex gap-x-4 gap-y-4 items-center justify-center md:w-[45rem] lg:w-[55rem] flex-wrap">
              <TextField
                type="text"
                name="q"
                placeholder="Enter city or state, school name"
                className="bg-white rounded-sm w-full"
              />
              <button
                type="submit"
                className="px-12 py-4 bg-blue-500 hover:bg-blue-600 text-white rounded-lg normal-case font-semibold"
              >
                Search Schools
              </button>
              <button
                type="button"
                onClick={() => setOpenQuiz(true)}
                className="px-12 py-4 text-sm font-semibold text-white rounded-lg normal-case"
              >
                Take our Home Match Quiz
              </button>
              {Quiz && (
                <>
                  <Quiz open={openQuiz} onClose={() => setOpenQuiz(false)} />
                </>
              )}
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};
